export default __webpack_public_path__ + "static/media/logo.01e93419.png";